import React, { useEffect, useState } from "react";
import PdfViewer from "../components/PdfViewer";

const samplePdf = 'prueba.pdf';
//RepPrA
const Ayuda = () =>{
    
    return(
        <div style={{position:'absolute', width:'100%',height:'100%'}}>
            <object
                data={require("../docs/Manual de usuario.pdf")}
                type="application/pdf"
                width="100%"
                height="100%"
            />
        </div>
    );
}

export default Ayuda;